module.exports = __webpack_public_path__ + "img/data-center05.acb82c74.png";